import styled from 'styled-components';

export const PageWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 30px;
	gap: 40px;
`;

export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
`;

export const FlexCol = styled.div`
	display: flex;
	flex-direction: column;
`;
